<bw-action-card-legacy
  (ctaClicked)="routeToSpending()"
  [cardConfig]="spendingInitialCard"
></bw-action-card-legacy>
